import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import CookieValue from "../../../utils/cookie_value";
import Cookies from "universal-cookie";
import UserOptionsDropdown from "./UserOptionsDropdown";
import TextInput from "../../TextInput";
import FetchResource from "../../../utils/fetch_resource";
// import { disable } from "debug";
// import { options } from "colorette";
// import { select } from "async";

const api_base = process.env.API_URL;
const client_base = process.env.BASE_URL;

export default class UserShowMainContainer extends Component {
  constructor(props) {
    super(props);
    const random_pw = Math.random()
      .toString(36)
      .replace(/[^a-z|0-9]+/g, "")
      .substr(2, 12);
    this.state = {
      id: props.match.params.userId || "new",
      full_name: "",
      email: "",
      office_hours: "",
      office_location: "",
      role_lookup: null,
      univ_lookup: null,
      univ_lookup_id: null,
      active: true,
      university_opts: [],
      role_opts: [],
      // edit_mode: this.editMode(),
      data_ready: false,
      password: null,
      password_confirmation: null,
      notice_message: "",
      display_notice: false,
      display_error: false,
      errors: [],
      current_user_role: props.currentUserRole,
      can_update: false,
      country_authorizer: props.country_authorizer,
    };
  }

  componentDidMount = () => {
    this._isMounted = true;
    this.fetchUser()
      .then(() => {
        if (this._isMounted) {
          this.setState({ data_ready: true });
        }
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          const cookies = new Cookies();
          cookies.remove("user_auth");
          this.props.history.push("/log_in");
        } else {
          if (this._isMounted) {
            this.setState({ display_error: true });
          }
        }
      });
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  // componentDidUpdate = (prevProps, prevState, snapshot) => { /**placeholder**/ }

  fetchUser = () => {
    let { id } = this.state;
    const url =
      id == "new"
        ? api_base + "users/" + id
        : api_base + "users/" + id + "/edit";
    return FetchResource(url, "", this);
  };

  updateUser = () => {
    this.signupValidation();
    let body = {
      skip_session_flag: true,
      user: {
        full_name: this.state.full_name,
        email: this.state.email,
        office_hours: this.state.office_hours,
        office_location: this.state.office_location,
        role_lookup_id: this.state.role_lookup
          ? this.state.role_lookup.id
          : null,
        univ_lookup_id: this.state.univ_lookup
          ? this.state.univ_lookup.id
          : null,
        active: this.state.active,
        country_authorizer: this.state.country_authorizer,
      },
    };
    let success_msg =
      this.state.id == null
        ? "Success: created user."
        : "Success: updated user";
    if (!this.state.id) {
      body["user"]["password"] = this.state.password;
      body["user"]["password_confirmation"] = this.state.password_confirmation;
    }
    const url = api_base + "users/" + (this.state.id ? this.state.id : "");

    const reqOptions = {
      method: this.state.id ? "PATCH" : "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + CookieValue(),
      },
      body: JSON.stringify(body),
    };

    this.api_call(url, reqOptions)
      .then((data) => {
        if (!data.errors && data.res_status != "unauthorized") {
          if (this._isMounted) {
            this.setState(data);
            this.displayNotice(success_msg);
            this.props.history.push("/users");
          }
        } else {
          if (this._isMounted) {
            // this.displayError(data.errors);
            this.setState({ display_error: true });
            this.setState({ errors: data.errors });
          }
        }
      })
      .catch((err) => {
        if (this._isMounted) {
          this.setState({ display_error: true });
        }
      });
  };

  signupValidation = () => {
    let errors = [];
    const names = {
      email: "Email",
      full_name: "Full name",
      univ_lookup_id: "University",
      role_lookup_id: "Role",
      password: "Password",
      password_confirmation: "Password Confirmation",
    };
    if (this.state.errors) {
      for (const [key, value] of Object.entries(this.state.errors)) {
        const name = names[key] || key;

        errors.push(`${name}: ${value}`);
      }
    }
    if (errors.length > 0 && this.state.display_error == true) {
      return (
        <div className="row">
          <div className="col-12 text-center">
            <ul className="alert alert-danger">
              {errors.map((e) => (
                <li key={e}>{e}</li>
              ))}
            </ul>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  };

  // signupValidation = () => {
  //   console.log("ERRORS", this.state.errors);
  //   if (this.state.errors != undefined) {
  //     let errors = [];
  //     if (
  //       this.state.errors.email != undefined &&
  //       this.state.errors.email.includes("can't be blank")
  //     ) {
  //       errors.push("Please add your email address");
  //     }
  //     if (
  //       this.state.errors.email != undefined &&
  //       this.state.errors.email.includes("is invalid")
  //     ) {
  //       errors.push("Invalid email address");
  //     }
  //     if (
  //       this.state.errors.email != undefined &&
  //       this.state.errors.email.includes("has already been taken")
  //     ) {
  //       errors.push("Email is already in use");
  //     }
  //     if (this.state.errors.full_name == "can't be blank") {
  //       errors.push("Please add full name");
  //     }
  //     if (
  //       this.state.errors.email != undefined &&
  //       this.state.errors.email.includes("has already been taken")
  //     ) {
  //       errors.push("Email is already in use");
  //     }
  //     if (this.state.errors.univ_lookup_id == "can't be blank") {
  //       errors.push("Please select a university");
  //     }
  //     if (
  //       this.state.errors.password != undefined &&
  //       this.state.errors.password.includes(" can't be blank.")
  //     ) {
  //       errors.push("Please enter a password");
  //     }
  //     if (
  //       this.state.errors.password != undefined &&
  //       this.state.errors.password.includes(
  //         "is too short (minimum is 8 characters)"
  //       )
  //     ) {
  //       errors.push("Password must be 8 characters or more");
  //     }
  //     if (this.state.errors.role_lookup_id == "can't be blank") {
  //       errors.push("Please select a role");
  //     }
  //     if (
  //       this.state.errors.password_confirmation != undefined &&
  //       this.state.errors.password_confirmation.includes(" can't be blank.")
  //     ) {
  //       errors.push("Please confirm password");
  //     }
  //     if (
  //       this.state.errors.password_confirmation != undefined &&
  //       this.state.errors.password_confirmation.includes(
  //         "doesn't match Password"
  //       )
  //     ) {
  //       errors.push("Password and password confirmation must match");
  //     }

  //     if (errors.length > 0 && this.state.display_error == true) {
  //       return (
  //         <div className="row">
  //           <div className="col-12 text-center">
  //             <ul className="alert alert-danger">
  //               {errors.map((e) => (
  //                 <li key={e}>{e}</li>
  //               ))}
  //             </ul>
  //           </div>
  //         </div>
  //       );
  //     } else {
  //       return <div />;
  //     }
  //   }
  // };

  deleteUser = () => {
    let state = this.state;
    const url = api_base + "users/" + state.id;
    const body = { user: { active: false } };
    const reqOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + CookieValue(),
      },
      // "Authorization": "Bearer " + token,
      body: JSON.stringify(body),
    };
    if (confirm("Are you sure you want to delete " + state.full_name + "?")) {
      this.api_call(url, reqOptions)
        .then((data) => {
          // console.log('data', data)
          if (!data.errors && data.res_status != "unauthorized") {
            let s = this.state;
            //remove the deleted syllabus from the state
            s.users.splice(idx, 1);
            s.display_error = false;
            s.notice = "";
            this.setState(s);
          } else {
            this.setState({ display_error: true, notice: "Unauthorized" });
            window.scrollTo(0, 0);
          }
        })
        .catch((err) => console.log);
    }
  };

  handleTextChange = (key, event) => {
    let state = this.state;
    state[key] = event.target.value;
    this.setState(state);
  };

  handleDropdownChange = (options, event) => {
    let { key, ddOpts } = options;
    let optsById = ddOpts.reduce((acc, v) => {
      acc[v.id] = v;
      return acc;
    }, {});
    let selection = optsById[event.target.value];
    let data = {};
    data[key.toString()] = selection;
    this.setState(data);
  };

  api_call = (url, reqOptions) => {
    return new Promise((resolve, reject) => {
      try {
        fetch(url, reqOptions).then((res) => {
          console.log("REQ", reqOptions);
          console.log("RES", res);
          res.json().then((data) => resolve(data));
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  // displayError = (error) => {
  //   let message;
  //   if (error instanceof Array) {
  //     message = error.join(", ");
  //   } else if (error instanceof String) {
  //     message = error;
  //   } else if (error instanceof Object) {
  //     message = Object.keys(error)
  //       .map((key) => {
  //         return `${key} ${error[key]}`;
  //       })
  //       .join(", ");
  //   }
  //   this.setState({
  //     data_ready: true,
  //     notice_message: message,
  //     display_error: true,
  //     display_notice: false,
  //   });
  // };

  displayNotice = (message) => {
    this.setState({
      data_ready: true,
      notice_message: message,
      display_error: false,
      display_notice: true,
    });
  };

  handleToggleAuth = () => {
    if (this.state.role_lookup == null) {
      console.log("HERE?", this.state.role_lookup);
      this.state.role_opts.map((opt) => {
        if (opt.name == "FACULTY") {
          console.log("FACULTY", opt);
          this.setState({ role_lookup: opt });
        }
      });
    } else {
      this.setState({ role_lookup: null });
    }
  };

  handleToggleNotification = (event) => {
    let univ = event.target.value;
    this.setState({ country_authorizer: univ });
  };

  toggleNotifications = () => {
    if (
      this.props.currentUserRole == "ADMIN" &&
      this.state.role_lookup != null &&
      this.state.role_lookup.name == "ADMIN"
    ) {
      return (
        <div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              value=""
              id="eguniv"
              onChange={this.handleToggleNotification}
              checked={this.state.country_authorizer == ""}
            />
            <label className="form-check-label" htmlFor="flexCheckChecked">
              No email notifications
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              value="eguniv"
              id="eguniv"
              onChange={this.handleToggleNotification}
              checked={this.state.country_authorizer == "eguniv"}
            />
            <label className="form-check-label" htmlFor="flexCheckChecked">
              Receive Egyptian signup notifications
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              value="usuniv"
              id="usuniv"
              onChange={this.handleToggleNotification}
              checked={this.state.country_authorizer == "usuniv"}
            />
            <label className="form-check-label" htmlFor="flexCheckChecked">
              Receive USA signup notifications
            </label>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  };

  render() {
    let {
      id,
      email,
      full_name,
      office_hours,
      office_location,
      role_lookup,
      univ_lookup,
      univ_lookup_id,
      university_opts,
      role_opts,
      // edit_mode,
      data_ready,
      password,
      password_confirmation,
      notice_message,
      display_notice,
      display_error,
      can_update,
      current_user_role,
    } = this.state;

    const page_title = id ? "Edit " + full_name : "Create User";

    const password_fields = id ? (
      ""
    ) : (
      <fieldset>
        <TextInput
          valText={password}
          inputType="password"
          editMode={can_update}
          fieldName="password"
          labelText="Password:"
          handleChange={this.handleTextChange}
        />
        <TextInput
          valText={password_confirmation}
          inputType="password"
          compareVal={password}
          editMode={can_update}
          fieldName="password_confirmation"
          labelText="Password Confirmation:"
          handleChange={this.handleTextChange}
        />
      </fieldset>
    );

    const notice =
      display_error || display_notice ? (
        <div
          role="alert"
          className={
            "card inner-buffer " +
            (display_error ? "alert alert-danger" : "alert alert-success")
          }
        >
          {notice_message}
        </div>
      ) : (
        ""
      );

    const changePwBtn =
      id && can_update ? (
        <a href={process.env.BASE_URL + "changepw/" + id}>
          <button
            className="btn btn-info xs-font ml-3"
            style={{ lineHeight: "100%" }}
          >
            change password
          </button>
        </a>
      ) : (
        ""
      );

    const toggleRoleAuth =
      this.props.currentUserRole == "UNIVERSITY COORDINATOR" ? (
        <div>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id={
                this.state.role_lookup == null
                  ? "flexSwitchCheckDefault"
                  : "flexSwitchCheckChecked"
              }
              onChange={this.handleToggleAuth}
              checked={this.state.role_lookup == null ? false : true}
            ></input>
            <label
              className="form-check-label"
              htmlFor="flexSwitchCheckDefault"
            >
              Authorized
            </label>
          </div>
        </div>
      ) : (
        // <button
        //   className="btn btn-primary mt-4"
        //   type="submit"
        //   onClick={this.handleToggleAuth}
        // >
        //   Authorize
        // </button>
        <UserOptionsDropdown
          label="Role:"
          dropDownVal={role_lookup}
          options={role_opts}
          lookupType="role_lookup"
          editMode={can_update}
          handleChange={this.handleDropdownChange}
        />
      );

    return data_ready ? (
      <div className="container">
        {this.signupValidation()}
        <h1>
          {page_title}
          {changePwBtn}
        </h1>
        <div className="card inner-buffer w-50">
          <TextInput
            valText={email}
            editMode={can_update}
            fieldName="email"
            labelText="Email:"
            handleChange={this.handleTextChange}
          />
          <TextInput
            valText={full_name}
            editMode={can_update}
            fieldName="full_name"
            labelText="Full Name:"
            handleChange={this.handleTextChange}
          />
          <UserOptionsDropdown
            label="University:"
            dropDownVal={univ_lookup}
            options={university_opts}
            lookupType="univ_lookup"
            editMode={can_update}
            handleChange={this.handleDropdownChange}
          />
          <div className="inner-buffer">{toggleRoleAuth}</div>
          {this.toggleNotifications()}
          {/* <TextInput
            valText={office_hours}
            editMode={can_update}
            fieldName="office_hours"
            labelText="Office Hours:"
            handleChange={this.handleTextChange}
          />
          <TextInput
            valText={office_location}
            editMode={can_update}
            fieldName="office_location"
            labelText="Office Location:"
            handleChange={this.handleTextChange}
          /> */}
          {password_fields}
          {can_update ? (
            <button
              className="btn btn-primary mt-4"
              type="submit"
              onClick={this.updateUser}
            >
              Save
            </button>
          ) : (
            ""
          )}
          {can_update && page_title != "Create User" ? (
            <a href={process.env.BASE_URL + "users"}>
              <button
                className="btn btn-danger mt-4"
                alt="delete"
                type="submit"
                onClick={this.deleteUser}
              >
                Delete This User
              </button>
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
    ) : (
      <div className="spinner"></div>
    );
  }
}
